/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Group_Research_AnalysisInputs */



/**
* | output |
* | --- |
* | "Research & analysis" |
*
* @param {Onboarding_Usage_Group_Research_AnalysisInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_group_research_analysis = /** @type {((inputs?: Onboarding_Usage_Group_Research_AnalysisInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Group_Research_AnalysisInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Recherche & Analyse")
	return /** @type {LocalizedString} */ ("Research & analysis")
});